/// <reference path="skyward.base.global.js" />
/// <reference path="skyward.ui.window.js" />
/// <reference path="skyward.ui.controls.js" />
/// <reference path="skyward.ui.modallayer.js" />
(
    function (skyward, $, undefined)
    {
        skyward.thresholds = skyward.thresholds || {};

        var init = function (selector)
        {
            // Initialize Rule Type Combobox
            if ($(selector).find(".ruleTypeSelector").length > 0)
            {
                var element = $(selector).find(".ruleTypeSelector");
                element.each(handleRuleTypeChange.bind(element, selector));
                element.change(handleRuleTypeChange.bind(element, selector));
            }
            // Initialize Test Version Field Selector
            if ($(selector).find('[id*="TestVersionFieldID-add"][id$="_value"]').length > 0)
            {
                var element = $(selector).find('[id*="TestVersionFieldID-add"][id$="_value"]');
                element.off("change", changeAssessmentTestField).on("change", changeAssessmentTestField);
                element.trigger("change")
            }

            if ($(selector).find('[id*="editThresholdRuleGroup_TestVersionFieldID"][id$="_value"]').length > 0)
            {
                var element = $(selector).find('[id*="editThresholdRuleGroup_TestVersionFieldID"][id$="_value"]');
                element.off("change", changeAssessmentTestField).on("change", changeAssessmentTestField);
            }

            if ($(selector).find('.js-ThresholdTestVersionID').length > 0)
            {
                var element = $(selector).find('.js-ThresholdTestVersionID');
                element.change(clearAssessmentCRQE);
            }

            if ($(selector).find('.js-useForMTSSCheckbox').length > 0)
            {
                var element = $(selector).find(".js-useForMTSSCheckbox");
                element.each(handleUseForMTSSChange);
                element.change(handleUseForMTSSChange);
            }

            if ($(selector).find('.js-skipEntityYearConditionCheckbox').length > 0)
            {
                var element = $(selector).find(".js-skipEntityYearConditionCheckbox");
                var ruleTypeElement = $(selector).find(".ruleTypeSelector");
                // handleRuleTypeChange assumes "this" is the ruleTypeSelector
                element.each(handleRuleTypeChange.bind(ruleTypeElement, selector));
                processSkipEntitySchoolYearDependents(selector, skyward.controls.getValue(element), skyward.controls.getValue(ruleTypeElement), true);
                element.change(function ()
                {
                    handleRuleTypeChange.call(ruleTypeElement, selector);
                    processSkipEntitySchoolYearDependents(selector, skyward.controls.getValue($(this)), skyward.controls.getValue(ruleTypeElement));
                });
                // also set up another change event on RuleType so that control visibility always stays up-to-date
                ruleTypeElement.change(function ()
                {
                    processSkipEntitySchoolYearDependents(selector, skyward.controls.getValue(element), skyward.controls.getValue($(this)));
                });
            }

            if ($(selector).find(".js-otherEntityIDs").length > 0)
            {
                $(selector).find(".js-otherEntityIDs").change(function ()
                {
                    skyward.controls.clearValue($(".js-clearOnEntityChange", selector));
                });
            }

            if ($(selector).find(".js-otherSchoolYearIDs").length > 0)
            {
                $(selector).find(".js-otherSchoolYearIDs").change(function ()
                {
                    skyward.controls.clearValue($(".js-clearOnSchoolYearChange", selector));
                });
            }

            var useForCheckboxGroup = $(selector).find(".js-thresholdGroupUseFor");
            if (useForCheckboxGroup.length > 0)
            {
                useForCheckboxGroup.debounce("change", function ()
                {
                    processUseForDependents(selector, $(this));
                }, 10);
                processUseForDependents(selector, useForCheckboxGroup, true);
            }

            // RuleTypes that require "Number of Occurrences = 1" helper
            $(selector).find(".js-thresholdRuleGroupID").on("eelComplete", ".codeEEL", handleReadonlyRuleTypes);
            // This ensures any of the readonly rules are made readonly and "Number of Occurences = 1" at page load
            // At page load, the .codeEELCode textbox has data-additional-fields, not the .codeEEL container
            $(selector).find(".js-thresholdRuleGroupID .codeEELCode").each(handleReadonlyRuleTypes);
        };

        var clearAssessmentCRQE = function () {
            var viewer = $(this).parents('[id$="RuleConditionsDiv"]');
            var ruleConditionQuickEntryfs = viewer.find("#TestVersionFieldCRQE");
            ruleConditionQuickEntryfs.find(".childrecordquickentryclearbuttoncell, .childrecordquickentryremovebuttoncell").each(function () { $(this).find('.button').click(); });
        }

        var handleRuleTypeChange = function (selector)
        {
            var ruleTypeInput = $(this);
            changeRuleType(ruleTypeInput, selector, false);
        };

        var changeRuleType = function (ruleTypeInput, selector)
        {
            var editThresholdRuleGroupSelector = '#editThresholdRuleGroup';
            var primaryKey;
            if (ruleTypeInput[0].id.startsWith('editThresholdRuleGroup') && $(editThresholdRuleGroupSelector).length > 0)
            {
                primaryKey = $(editThresholdRuleGroupSelector).data('primaryid');
            }

            $.ajax({
                url: skyward.global.virtualDir + "Student/ThresholdRuleGroup/GetAllRuleConditionsForType",
                type: "POST",
                dataType: "viewparthtml",
                data:
                {                        
                    ruleTypeCode: ruleTypeInput.val(),
                    primaryKey: primaryKey,
                    entityID: $("input[name='EntityID']", selector).val(),
                    schoolYearID: $("input[name='SchoolYearID']", selector).val(),
                    skipEntitySchoolYearFilter: $(".js-skipEntityYearConditionCheckbox", selector).prop("checked"),
                    otherEntityIDs: skyward.controls.getValue($(".js-otherEntityIDs", selector)),
                    otherSchoolYearIDs: skyward.controls.getValue($(".js-otherSchoolYearIDs", selector)),
                    otherEntityIDsControl: $(".js-otherEntityIDs", selector).attr("name"),
                    otherSchoolYearIDsControl: $(".js-otherSchoolYearIDs", selector).attr("name")
                },
                success: function (data)
                {
                    var ruleConditionsSelector = '#' + ruleTypeInput.parent().siblings('.ruleConditions')[0].id;
                    if ($(ruleConditionsSelector, selector)[0])
                    {
                        $(ruleConditionsSelector, selector).html(data);
                        skyward.window.notifyDOMLoad(ruleConditionsSelector);
                    }
                }
            });
        };                

        var changeAssessmentTestField = function (ruleTypeInput)
        {
            var testVersionFieldInput = $(this);
            var primaryKey = testVersionFieldInput.val();
            var id = testVersionFieldInput[0].id;
            var idEnding = id.substring(id.indexOf("-"), id.lastIndexOf("_value"));
            var isDetails = id.includes('edit');
            $.ajax({
                url: skyward.global.virtualDir + "Student/ThresholdRuleGroup/UpdateAssessmentValueViewPart",
                type: "POST",
                dataType: "viewparthtml",
                data:
                {                        
                    testVersionFieldID: primaryKey,
                    keyEnding: idEnding,
                    isDetails: isDetails,
                },
                success: function (valueData)
                {
                    var ruleConditionsSelector = testVersionFieldInput.closest(".childrecordquickentryrow").find('.js-TestVersionFieldValueOuterDiv')[0];
                    ruleConditionsSelector.innerHTML = valueData;
                    skyward.window.notifyDOMLoad(ruleConditionsSelector);

                    $.ajax({
                        url: skyward.global.virtualDir + "Student/ThresholdRuleGroup/UpdateAssessmentOperation",
                        type: "POST",
                        dataType: "viewparthtml",
                        data:
                        {                        
                            testVersionFieldID: primaryKey,
                            keyEnding: idEnding,
                            isDetails: isDetails,
                        },
                        success: function (operationData) //want this to run after control is loaded so dependents fire
                        {

                            var ruleConditionsSelector = testVersionFieldInput.closest(".childrecordquickentryrow").find('.js-TestVersionFieldOperationOuterDiv')[0];
                            ruleConditionsSelector.innerHTML = operationData;
                            skyward.window.notifyDOMLoad(ruleConditionsSelector);
                        }
                    });
                }
            });
        };

        var handleUseForMTSSChange = function ()
        {
            var useForMTSSCheckbox = $(this);

            if (useForMTSSCheckbox[0].checked)
            {
                $('.fsTier').show();
            }
            else
            {
                $('.fsTier').hide();
                $('.fsTier').find('.js-TierEEL').each(function ()
                {
                    skyward.controls.clearValue(this.parentElement);
                })
            }
        };

        /**
         * Used to handle visibility and clearing for dependents that are shared between multiple Use For options.
         * Otherwise, when unchecking an option individually, the framework dependent logic won't do what
         * we want because it will go to inverse a visible=true dependent when unchecking a checkbox even if another
         * checkbox in the group is checked and has the same visible=true dependent.
         */
        var processUseForDependents = function (selector, useForCheckboxGroup, isPageLoad)
        {
            var studentIndicatorFieldset = $(selector).find(".js-fsShowStudentIndicator");
            var studentIndicatorCheckbox = $(selector).find(".js-showStudentIndicator");
            var gradeLevelFieldset = $(selector).find(".js-fsGradeLevels");
            var gradeLevelDMSE = $(selector).find(".js-gradeLevels");

            var selectedOptions = {};
            useForCheckboxGroup.find(".checkbox").each(function ()
            {
                var checkboxName = $(this).attr("name");
                if (checkboxName.includes("selectAll"))
                {
                    return;
                }

                // Grab the last part of the dotted path (for workflows)
                var dotParts = checkboxName.split(".");
                if (dotParts.length > 1)
                {
                    checkboxName = dotParts[dotParts.length - 1];
                }

                selectedOptions[checkboxName] = skyward.controls.getValue($(this));
            });

            var useForAthleticEligibility = selectedOptions["UseForAthleticEligibility"];
            var useForAcademicEligibility = selectedOptions["UseForAcademicEligibility"];
            var useForMTSS = selectedOptions["UseForMTSS"];
            var useForScheduling = selectedOptions["UseForScheduling"];

            if (useForAthleticEligibility || useForAcademicEligibility || useForMTSS || useForScheduling)
            {
                skyward.controls.show(studentIndicatorFieldset);
            }
            else
            {
                skyward.controls.hide(studentIndicatorFieldset);

                if (!isPageLoad)
                {
                    skyward.controls.clearValue(studentIndicatorCheckbox);
                }
            }

            if (useForAthleticEligibility || useForAcademicEligibility || useForMTSS)
            {
                skyward.controls.show(gradeLevelFieldset);
            }
            else
            {
                skyward.controls.hide(gradeLevelFieldset);

                if (!isPageLoad)
                {
                    skyward.distinctmultiselecteel.clearValue(gradeLevelDMSE);
                }
            }

            console.log(JSON.stringify(selectedOptions));
        };

        var processSkipEntitySchoolYearDependents = function (selector, skipEntitySchoolYearSelector, selectedRuleTypeCode, isInitialPageLoad)
        {
            var isEntitySpecific = true;

            // Check for all codes that filter by DistrictID instead of EntityID
            if (selectedRuleTypeCode == "GP") // GPA
            {
                isEntitySpecific = false;
            }

            if (skipEntitySchoolYearSelector && isEntitySpecific)
            {
                skyward.controls.show($(".js-entitiesSelect", selector));
            }
            else
            {
                skyward.controls.hide($(".js-entitiesSelect", selector));
            }

            if (skipEntitySchoolYearSelector)
            {
                skyward.controls.show($(".js-schoolYearsSelect", selector));
            }
            else
            {
                skyward.controls.hide($(".js-schoolYearsSelect", selector));
            }

            if (isInitialPageLoad)
            {
                return;
            }

            skyward.controls.clearValue($(".js-otherEntityIDs,.js-otherSchoolYearIDs", selector));
        };

        var handleReadonlyRuleTypes = function ()
        {
            var numberOfOccurences = $(this).parents(".js-thresholdRuleGroupID").siblings(".js-numberOfOccurrences").find(".number");
            if (numberOfOccurences.length === 0)
            {
                return;
            }

            var operationTypeCode = $(this).parents(".js-thresholdRuleGroupID").siblings(".js-operationTypeCode").find(".comboBoxSet");
            if (operationTypeCode.length === 0)
            {
                return;
            }

            var ruleTypesToForceReadonly = ["SD", "SP"];

            var additionalFieldsData = $(this).data("additionalFields");
            if (!additionalFieldsData || !additionalFieldsData["RuleTypeCode"] ||
                !ruleTypesToForceReadonly.includes(additionalFieldsData["RuleTypeCode"]))
            {
                skyward.controls.enable(numberOfOccurences);
                skyward.controls.enable(operationTypeCode);
                return;
            }

            skyward.controls.setValue(numberOfOccurences, 1);
            skyward.controls.disable(numberOfOccurences);
            skyward.controls.setValue(operationTypeCode, "GTOE");
            skyward.controls.disable(operationTypeCode);
        };

        ////Bootstrap
        skyward.window.registerLoadDOMCallback(init);
    }(window.skyward = window.skyward || {}, window.jQuery)
);
